import ApplicationController from '../../support/application_controller'
import { disableElement } from '../../support/helpers'

export default class extends ApplicationController {

  static targets = [
    'disableOnConfirm',
    'maxConsultationsFlash',
    'submit'
  ]

  // ==== Controllers

  // ==== Actions

  selectClinician({ params: { maxConsultationsReached } }) {
    this.submitTarget.disabled = false
    this.maxConsultationsFlashTarget.classList.toggle('u-hide', !maxConsultationsReached)
  }

  confirm() {
    for (const el of this.disableOnConfirmTargets) {
      disableElement(el)
    }
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
